import { commentsData } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">观众热评</h2>
          <p className="text-sm text-foreground-500 mt-2">真实观众的使用体验与追剧分享</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
          {commentsData.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>

              <div className="mb-3">
                <span className="inline-block px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                  在看 {comment.drama}
                </span>
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>

              <div className="flex items-center gap-4 mt-4 pt-3 border-t border-background-200">
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}